import { Grid, TextInput } from '@ts/storybook';
import { convertFromMilliseconds } from '@ts/ui-models';
import { useEffect, useState } from 'react';

export const unitsMap = {
  days: 'days',
  hours: 'hours',
  minutes: 'minutes',
  seconds: 'seconds',
  // milliseconds: 'milliseconds',
  // w: "weeks",
  // M: "months",
  // y: "years"
};

export const convertToMilliseconds = ({ days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0 }) => {
  return days * 24 * 60 * 60 * 1000 + hours * 60 * 60 * 1000 + minutes * 60 * 1000 + seconds * 1000 + milliseconds;
};

interface IDurationProps {
  isReadOnly?: boolean;
  disabled?: boolean;
  value?: number;
  onChange?: (value: number) => void;
  error?: boolean;
}

const Duration = ({ isReadOnly, disabled, value = 0, onChange, error }: IDurationProps) => {
  const [localValues, setLocalValues] = useState(convertFromMilliseconds(value) as object);

  useEffect(() => {
    setLocalValues(convertFromMilliseconds(value) as object);
  }, [value]);

  const handleChange = (unit, number) => {
    const updated = { ...localValues, [unit]: number };
    setLocalValues(updated);
    if (onChange) onChange(convertToMilliseconds(updated));
  };
  return (
    <Grid container spacing={3}>
      {Object.keys(unitsMap).map(unit => (
        <Grid size={{ xs: 'auto' }} key={unit}>
          <TextInput
            type="number"
            isReadOnly={isReadOnly}
            onChangeValue={v => handleChange(unit, v)}
            placeholder="0"
            value={value === 0 ? undefined : localValues[unit]}
            disabled={disabled}
            label={unitsMap[unit]}
            min={0}
            errorHint={error ? ' ' : ''}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default Duration;
